import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { useResetPasswordMutation } from '@src/features/auth/redux';
import { routesConfig } from '@src/core/routes';
import { IResetPasswordForm } from '@src/features/auth/pages/reset-password-page/types';
import { toast } from 'react-toastify';
import { trackError, toTrackedError } from '@src/core/sentry';

export const useResetPasswordForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [resetPassword, { isLoading }] = useResetPasswordMutation();
  const form = useForm<IResetPasswordForm>();

  const onSubmit = (data: IResetPasswordForm) => {
    const params = new URLSearchParams(location.search);
    resetPassword({
      ...data,
      key: params.get('key') as string,
    }).unwrap()
      .then(() => {
        navigate(routesConfig.signIn, { replace: true });
        toast.success('success');
      })
      .catch((err: unknown) => {
        trackError(toTrackedError(err), { code: 'FE_0022', extra: { flow: 'resetPassword' } });
      });
  };

  return {
    ...form,
    onSubmit: form.handleSubmit(onSubmit),
    isLoading,
  };
};

